import { ALL_VALID_EXTENSIONS } from './constants'
import { MIME_TYPE, MIME_TYPES, StandarizedDisplayType } from './types/files'
export const formatBytes = (bytes: number, decimals = 2): string => {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export const isValidExtension = (
  potentialExtension: string,
): potentialExtension is keyof MIME_TYPES => {
  return ALL_VALID_EXTENSIONS.includes(potentialExtension)
}

export const getFileExtension = (fileName: string): string => {
  const extension = fileName.split('.').pop()

  return !extension || !isValidExtension(extension) ? '' : extension
}

export const blobToBase64 = async (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(blob)
    reader.onloadend = () => resolve(reader.result?.toString() ?? '') // readAsDataURL resolves to base64 string. JS mucho retarded
    reader.onerror = () => reject()
  })
}

export const standarizedType = (
  type: MIME_TYPE,
): StandarizedDisplayType | null => {
  switch (type) {
    case 'application/pdf':
      return 'pdf'

    case 'text/csv':
      return 'csv'

    case 'video/mp4':
      return 'video'

    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'document'

    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'sheet'

    case 'application/vnd.ms-powerpoint':
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    case 'application/vnd.microsoft.portable-executable':
      return 'presentation'

    case 'image/png':
    case 'image/gif':
    case 'image/jpeg':
    case 'image/svg+xml':
    case 'image/webp':
      return 'image'
  }
}
